<template>
  <div class="encryption">
    <appHeader activeIndex="encryption"></appHeader>
    <div class="encryptionContent">
      <img class="banner" src="../../assets/img/products/encryption/banner.png" alt />

      <div class="encryptionIntroduction">
        <div class="encryptionInfo">
          <div class="encryptionInfo1">
            <img class="encryptionInfo1Img1" src="../../assets/img/Product/encryption.png" alt />
            <br><br>
            <div class="encryptionTitle1">手机加密管家</div>
            <div class="encryptionTitle2">为你的手机加上安全锁，保护您的个人隐私！</div>
            <br><br>
            <img class="encryptionInfo1Img2" src="../../assets/img/products/encryption/encryptionIcon.png" alt />
          </div>
          <div class="encryptionInfo2">
            <p>
              【应用锁加密】打开本款APP，第一步为您设置APP解锁密码，把您的私密图片、视频等文件，全都加上安全锁，充分保护您的隐私！
            </p>
            <p>
              【私密图片】把珍藏的图片放在本款APP中吧，导入即可，创建您的私密图片文件夹，不同类型的图片放在不同的文件夹里面，分类管理更好用！
            </p>
            <p>
              【私密视频】那些只有自己能看的视频，就悄悄放在本款APP中吧，跟私密图片一样，按照文件夹保存起来，其他人再也看不到哦！
            </p>
            <p>
              【多元化编辑】支持给私密图片和视频添加封面、重命名、导出等等功能，让您的私人空间更加个性化！
            </p>
            <p>
              ㅤ用手机加密管家保护您的私密图片和视频吧！
            </p>
            
          </div>
        </div>
        <el-divider></el-divider>
        <div class="encryptionCarousel">
          <!-- <div class="iconLeft" @click="left">
            <el-button icon="el-icon-arrow-left" circle></el-button>
          </div>
          <div class="iconRight" @click="right">
            <el-button icon="el-icon-arrow-right" circle></el-button>
          </div> -->
          <div class="encryptionWrap">
            <img
              class="encryptionMainImg"
              :style="{ 'margin-left': nowLeft + '%' }"
              src="../../assets/img/products/encryption/carousel.png"
              alt
            />
          </div>
        </div>
      </div>
    </div>
    <appFooter></appFooter>
  </div>
</template>
 
<script>
import appHeader from "../components/Header";
import appFooter from "../components/Footer";
export default {
  components: {
    appHeader,
    appFooter
  },
  data() {
    return {
      nowLeft: 0
    };
  },
  methods: {
    left() {
      if (this.nowLeft >= 0) {
        return;
      }
      this.nowLeft = this.nowLeft + 14;
    },

    right() {
      if (this.nowLeft <= -14) {
        return;
      }
      this.nowLeft = this.nowLeft - 14;
    }
  }
};
</script>
<style>
@import "../../assets/css/products/encryption.css";
</style>
